import { Loading, Select, View } from '@acin/ui-core';
import styled from 'styled-components';

// This named style should be the wrapper for the component i.e. the module
export const ControlMappingsRuns = styled(View)``;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${(p) => p.theme.spacing.getSize(3)};
`;

export const Filters = styled.div`
  display: flex;
`;

export const ClientFilter = styled(Select)``;

export const RegulationFilter = styled(Select)`
  margin-left: ${(p) => p.theme.spacing.getSize(3)};
`;

export const Sentinel = styled.div`
  height: ${(p) => p.theme.spacing.getSize(5)};
  visibility: hidden;
`;

export const LoadingIndicator = styled(Loading)`
  display: block;
  margin: ${(p) => p.theme.spacing.getSize(3)} 0;
`;
